import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DependencyTrackerClass;
function DependencyTracker() {
  if (DependencyTrackerClass === VOID) {
    class $ {
      constructor() {
        this.hai_1 = ArrayList().w();
        this.iai_1 = ArrayList().w();
      }
      jai(listenable) {
        this.iai_1.v(listenable);
        if (this.hai_1.p1() > this.iai_1.p1()) {
          var maybe = this.hai_1.q1(this.iai_1.p1()).af_1;
          if (equals(maybe, listenable)) {
            return !(maybe == null) ? maybe : THROW_CCE();
          }
        }
        // Inline function 'kotlin.collections.find' call
        var tmp0 = this.hai_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (equals(element.af_1, listenable)) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        var tmp0_safe_receiver = tmp$ret$1;
        var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.af_1;
        return (tmp == null ? true : !(tmp == null)) ? tmp : null;
      }
      kai(any, remove) {
        var tmp0 = this.hai_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = to(any, remove);
        tmp0.v(element);
      }
      lai() {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.hai_1.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          element.bf_1();
        }
        this.hai_1.v3();
      }
      mai() {
        this.iai_1.v3();
      }
      nai() {
        var iter = this.hai_1.m1();
        while (iter.n1()) {
          var entry = iter.o1();
          if (!this.iai_1.t1(entry.af_1)) {
            entry.bf_1();
            iter.l6();
          }
        }
      }
    }
    initMetadataForClass($, 'DependencyTracker');
    DependencyTrackerClass = $;
  }
  return DependencyTrackerClass;
}
//region block: exports
export {
  DependencyTracker as DependencyTracker2tg9lout2xnpn,
};
//endregion

//# sourceMappingURL=DependencyTracker.mjs.map
